import React from 'react';
import './../styles/index.css';

import { Table, Row, Button, Col } from 'react-bootstrap';

import { FaPlay } from 'react-icons/fa';
import { HiOutlineSave } from 'react-icons/hi';


import useSound from 'use-sound';

import { z010ma0a } from './sound.js';
import { z010ma0b } from './sound.js';
import { z010ma0c } from './sound.js';
import { z015ma0c } from './sound.js';
import { z010mi0a } from './sound.js';
import { z010mi0b } from './sound.js';
import { z010mi0c } from './sound.js';
import { z015mi0c } from './sound.js';
import { z020mi0a } from './sound.js';
import { z020mi0b } from './sound.js';
import { z020di0a } from './sound.js';
import { z020di0b } from './sound.js';
import { z030mi0a } from './sound.js';
import { z030mi0b } from './sound.js';
import { z630ma0a } from './sound.js';
import { z630ma0b } from './sound.js';
import { z040ma0a } from './sound.js';
import { z040ma0b } from './sound.js';
import { z040ma0c } from './sound.js';
import { z040mi0a } from './sound.js';
import { z040mi0b } from './sound.js';
import { z040mi0c } from './sound.js';
import { z050ma0a } from './sound.js';
import { z050ma0b } from './sound.js';
import { z050ma0c } from './sound.js';
import { z050ma7d } from './sound.js';
import { z050mi0a } from './sound.js';
import { z060mi0b } from './sound.js';
import { z060mi0a } from './sound.js';
import { z660ma0a } from './sound.js';
import { z660ma0b } from './sound.js';
import { z075di7a } from './sound.js';
import { z070di0b } from './sound.js';
import { z670ma0a } from './sound.js';


export default function DisplayPanel(props) {

    let results = props.results;
    let totalscore = props.totalscore;

    let myVolume = 1;
    if (props.volume === "off") myVolume = 0;

    const [playz010ma0a] = useSound(z010ma0a);
    const [playz010ma0b] = useSound(z010ma0b);
    const [playz010ma0c] = useSound(z010ma0c);
    const [playz015ma0c] = useSound(z015ma0c);
    const [playz010mi0a] = useSound(z010mi0a);
    const [playz010mi0b] = useSound(z010mi0b);
    const [playz010mi0c] = useSound(z010mi0c);
    const [playz015mi0c] = useSound(z015mi0c);
    const [playz020mi0a] = useSound(z020mi0a);
    const [playz020mi0b] = useSound(z020mi0b);
    const [playz020di0a] = useSound(z020di0a);
    const [playz020di0b] = useSound(z020di0b);
    const [playz030mi0a] = useSound(z030mi0a);
    const [playz030mi0b] = useSound(z030mi0b);
    const [playz630ma0a] = useSound(z630ma0a);
    const [playz630ma0b] = useSound(z630ma0b);
    const [playz040ma0a] = useSound(z040ma0a);
    const [playz040ma0b] = useSound(z040ma0b);
    const [playz040ma0c] = useSound(z040ma0c);
    const [playz040mi0a] = useSound(z040mi0a);
    const [playz040mi0b] = useSound(z040mi0b);
    const [playz040mi0c] = useSound(z040mi0c);
    const [playz050ma0a] = useSound(z050ma0a);
    const [playz050ma0b] = useSound(z050ma0b);
    const [playz050ma0c] = useSound(z050ma0c);
    const [playz050ma7d] = useSound(z050ma7d);
    const [playz050mi0a] = useSound(z050mi0a);
    const [playz060mi0b] = useSound(z060mi0b);
    const [playz060mi0a] = useSound(z060mi0a);
    const [playz660ma0a] = useSound(z660ma0a);
    const [playz660ma0b] = useSound(z660ma0b);
    const [playz075di7a] = useSound(z075di7a);
    const [playz070di0b] = useSound(z070di0b);
    const [playz670ma0a] = useSound(z670ma0a);

    //type defines whether user clicks on one notation only or is trying to place a series of notations. type = single/multiple
    const playSound = (code, clickedPos, type) => {


        switch (code) {
            case "z010ma0a":
                playz010ma0a();
                break;
            case "z010ma0b":
                playz010ma0b();
                break;
            case "z010ma0c":
                playz010ma0c();
                break;
            case "z015ma0c":
                playz015ma0c();
                break;
            case "z010mi0a":
                playz010mi0a();
                break;
            case "z010mi0b":
                playz010mi0b();
                break;
            case "z010mi0c":
                playz010mi0c();
                break;
            case "z015mi0c":
                playz015mi0c();
                break;
            case "z020mi0a":
                playz020mi0a();
                break;
            case "z020mi0b":
                playz020mi0b();
                break;
            case "z020di0a":
                playz020di0a();
                break;
            case "z020di0b":
                playz020di0b();
                break;
            case "z030mi0a":
                playz030mi0a();
                break;
            case "z030mi0b":
                playz030mi0b();
                break;
            case "z630ma0a":
                playz630ma0a();
                break;
            case "z630ma0b":
                playz630ma0b();
                break;
            case "z040ma0a":
                playz040ma0a();
                break;
            case "z040ma0b":
                playz040ma0b();
                break;
            case "z040ma0c":
                playz040ma0c();
                break;
            case "z040mi0a":
                playz040mi0a();
                break;
            case "z040mi0b":
                playz040mi0b();
                break;
            case "z040mi0c":
                playz040mi0c();
                break;
            case "z050ma0a":
                playz050ma0a();
                break;
            case "z050ma0b":
                playz050ma0b();
                break;
            case "z050ma0c":
                playz050ma0c();
                break;
            case "z050ma7d":
                playz050ma7d();
                break;
            case "z050mi0a":
                playz050mi0a();
                break;
            case "z060mi0b":
                playz060mi0b();
                break;
            case "z060mi0a":
                playz060mi0a();
                break;
            case "z660ma0a":
                playz660ma0a();
                break;
            case "z660ma0b":
                playz660ma0b();
                break;
            case "z075di7a":
                playz075di7a();
                break;
            case "z070di0b":
                playz070di0b();
                break;
            case "z670ma0a":
                playz670ma0a();
                break;
            default:
                console.log("default")
        }

    }



    function myLoop(resultsCombi) {         //  create a loop function
        var delayInMilliseconds = 500; //1 second
        var i = 0;

        if (resultsCombi.length !== 0) {
            setTimeout(function () {   //  call a 3s setTimeout when the loop is called
                playSound(resultsCombi[i], "", "multiple");

                resultsCombi.shift();
                myLoop(resultsCombi);             //  ..  again which will trigger another 
                //  ..  setTimeout()
            }, delayInMilliseconds)
        }
    }


    const playMultiSound = (resultsCombi) => {

        let mycombi = [];

        if (resultsCombi.length !== 0) {
            for (var key in resultsCombi) {
                mycombi.push(resultsCombi[key]);
            }

        }

        myLoop(mycombi);
    }


    const formDisplayCombi = (notationParts) => {

        return (
            <>
                {
                    notationParts.map((item, index) => {


                        return (
                            <React.Fragment key={index}>
                                <Col className="text-center">
                                    {props.chord === "American" && <><span className="supsub">{item.b_superscript !== null && <sup>{item.b_superscript}</sup>}</span>{item.main}<span className="supsub">
                                        {(item.superscript !== null && !item.superscript.includes("~")) && <sup>{item.superscript}</sup>}
                                        {(item.superscript !== null && item.superscript.includes("~")) && <sup><span className='specialFont'>{item.superscript.substring(0, 1).replace("~", "∅")}</span>{item.superscript.substring(1, 2)}</sup>}

                                        {item.subscript !== null && <sub>{item.subscript}</sub>}</span> </>}

                                    {props.chord === "British" && <><span className="supsub">{item.b_superscript !== null && <sup>{item.b_superscript}</sup>}</span>{item.main}<span className="supsub">
                                        {(item.british_superscript !== null && !item.british_superscript.includes("~")) && <sup>{item.british_superscript}</sup>}
                                        {(item.british_superscript !== null && item.british_superscript.includes("~")) && <sup><span className='specialFont'>{item.british_superscript.substring(0, 1).replace("~", "∅")}</span>{item.british_superscript.substring(1, 2)}</sup>}

                                        {item.british_subscript !== null && <sub>{item.british_subscript}</sub>} </span>{item.british_extra} </>}


                                </Col>

                            </React.Fragment>
                        );
                    })
                }
                {notationParts.length === 3 && <Col>&nbsp;</Col>}
            </>
        );
    }

    const reversedItems = results.map(item => item).reverse();

    const printpdf = (DivID) => {
        window.print();
    }

    //make date for printout
    let today = new Date();
    let dd = today.getDate();

    let mm = today.getMonth() + 1;
    let yyyy = today.getFullYear();
    if (dd < 10) {
        dd = '0' + dd;
    }

    if (mm < 10) {
        mm = '0' + mm;
    }

    today = dd + '-' + mm + '-' + yyyy;



    return (

        <div>
            <div id="printable" className="text-center" >
                <h1>Harmonia Submission</h1>
                {today}
                <br /><br />
                <Table width="200px" bordered>
                    <thead>
                        <tr>
                            <td>
                                No.
                            </td>
                            <td>
                                Progression
                            </td>
                            <td>
                                Score
                            </td>
                        </tr>
                    </thead>

                    <tbody>
                        {
                            reversedItems.map((item, index) => {
                                return (
                                    <tr key={index} className="table table-bordered">
                                        <td>
                                            {index + 1}
                                        </td>
                                        <td><Row>
                                            {formDisplayCombi(item.displayCombi)}
                                        </Row>
                                        </td>
                                        <td>
                                            {item.score}
                                        </td>
                                    </tr>
                                )
                            })

                        }
                        <tr>
                            <td>
                                &nbsp;
                            </td>
                            <td>
                                Total:
                            </td>
                            <td>
                                {totalscore}
                            </td>
                        </tr>

                    </tbody>

                </Table>

            </div>

            <Row id="non-printable" className="timer-gap">
                <Col xs={1}></Col>
                <Col>
                    <Row className="timer-gap">
                        <Col className="transparentBackground timerText text-center">
                            SCORE: {totalscore}
                        </Col>
                        {window.outerWidth < 1025 &&
                            <Col xs={2} className="text-center">
                                <Button className="bottomButton" type="button" onClick={() => printpdf("maincontent")}> <HiOutlineSave size={`${window.outerWidth < 1024 ? '30' : '50'}`} /></Button>
                            </Col>

                        }
                    </Row>

                    <Row className="transparentBackground displayFont">

                        <Col className="previewText displayHeight">
                            {
                                reversedItems.map((item, index) => {
                                    return (
                                        <Row key={index}>
                                            <Col xs={2}>{myVolume === 1 && <Button className="playButton" onClick={() => playMultiSound(item.soundCombi || item.combi)} ><FaPlay size={20} /></Button>}</Col>
                                            <Col className="purpleBackground"><Row>{formDisplayCombi(item.displayCombi)}</Row></Col>
                                            <Col xs={2}>{item.score}</Col>
                                        </Row>

                                    );
                                })
                            }
                        </Col>

                    </Row>

                    {window.outerWidth > 1024 &&
                        <Row>
                            <Col className="d-flex justify-content-center flex-row">
                                <Button className="bottomButton" type="button" onClick={() => printpdf("maincontent")}> Print | Save as PDF </Button>
                            </Col>
                        </Row>
                    }
                </Col>
                <Col xs={1}></Col>
            </Row>







        </div >
    )
}